app.service('basketDeliveryUnavailable', function (modal, html, loading, broker, updateServicePrices) {
	let $self, $form, $servicesOnModal, $summary;
	let modalContent;

	function open() {
		let modifier = '';
		if (modalContent) {
			modal.open('modal-delivery-unavailable');
		} else {
			if (html.has('new-services-reminder')) {
				modalContent = $('#delivery-unavailable-new').html();
				modifier = 'remodal-right new-services-list';
			} else {
				modalContent = $('#delivery-unavailable-old').html();
			}
			$('#delivery-unavailable-new, #delivery-unavailable-old').remove();
			modal.generate({
				id: 'modal-delivery-unavailable',
				content: modalContent,
				modifier: modifier,
				callbackOpen: function () {
					setElements();
					setEvents();
				}
			});
		}
	}

	function setElements() {
		$self = $('#modal-delivery-unavailable');
		$summary = $('.js-services-summary-price', $self);
		$form = $('form', $self);
		$servicesOnModal = $('.js-service', $form);
	}
	function setEvents() {
		$('.js-confirm-home-delivery', $self).on('click', function () {
			modal.close();
			broker.trigger('CONFIRM_HOME_DELIVERY');
		});
		$('.js-back-to-cart', $self).on('click', function () {
			modal.close();
			loading.redirect({
				href: '/cart.bhtml',
				soft: true
			})
		});
		$('.js-service-change-more', $self).on('click', function (event) {
			$(this).closest('.service-item').toggleClass('extended');
			event.stopPropagation();
			event.preventDefault();
		}).on('keyup keypress keydown', function (event) {
			event.stopPropagation();
		});
		$('.js-resign-home-delivery', $self).on('click', function () {
			modal.close();
			broker.trigger('RESIGN_HOME_DELIVERY');
		});

		$('.js-decline-home-delivery-type', $self).on('click', function () {
			modal.close();
			broker.trigger('DECLINE_HOME_DELIVERY', $(this).data('delivery-type') * 1);
		});
		$servicesOnModal.on('click', function () {
			updateExcludedServices.run({
				$input: $(this),
				$inputs: $servicesOnModal
			});
			updateServicePrices.run({
				$inputs: $servicesOnModal,
				$box: $summary
			});
		});
	}
	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			broker.on('REFRESH_BASKET_VIEW', function () {
				modalContent = false;
				modal.destroy('delivery-unavailable');
			});
			broker.on('RELOAD_CART_SUCCESS', function () {
				modalContent = false;
				modal.destroy('delivery-unavailable');
			});

		}
	}
	return {
		init,
		open
	};
});
